export default __webpack_public_path__ + "static/media/negative.61f905a7.svg";